<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" lg="3" md="6" sm="12" xl="3" xs="12">
        <v-card class="rounded-lg" elevation="1">
          <v-card-title>
            <h4 class="h6">Check Availability</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-7 pb-3 text-center">
            <v-autocomplete
              rounded
              :items="states"
              v-model="selectedState"
              label="State"
              item-text="state_name"
              item-value="state_id"
              outlined
              dense
              placeholder="State"
            ></v-autocomplete>
            <v-autocomplete
              rounded
              :items="districts"
              v-model="selectedDistrict"
              item-text="district_name"
              item-value="district_id"
              label="District"
              outlined
              dense
              @change="getSloteByDistrict()"
              placeholder="District"
            ></v-autocomplete>
            <v-btn
              @click="getSloteByDistrict()"
              :disabled="states.length == 0 || districts.length == 0"
              color="primary darken-1"
              large
              block
              elevation="0"
            >
              <v-icon>mdi-refresh</v-icon>
              Refresh
            </v-btn>
            <v-btn
              @click="saveTemp()"
              class="mt-4"
              outlined
              color="black"
              :disabled="states.length == 0 || districts.length == 0"
              block
              large
            >
              <v-icon>mdi-check</v-icon>
              Remember District</v-btn
            >

            <!-- <v-btn
              color="orange darken-1"
              class="my-4"
              block
              large
              to="/notifications"
              elevation="0"
            >
              <v-icon>mdi-bell</v-icon>
              Get Notifications</v-btn
            > -->
            <v-btn
              class="mt-2 text-center"
              text
              color="grey"
              @click="
                selectedState = '';
                selectedDistrict = '';
              "
              >reset</v-btn
            >
          </v-card-text>
        </v-card>
        <v-card rounded outlined class="mt-3 rounded-lg text-center" :color="(notificationCount>0?'green':'red')+' lighten-1'" to="/notifications" ripple>
          <v-card-title class="mb-2 pb-0"> <v-icon class="mr-2">mdi-bell</v-icon> Active Notifications</v-card-title>
          <v-divider></v-divider>
          <v-card-subtitle class="py-1 text-h3"> {{notificationCount}}</v-card-subtitle>
          <v-divider></v-divider>
          
          <v-card-action>
            <v-btn text block>Create One</v-btn>
          </v-card-action>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="rounded-lg" elevation="0">
          <v-card-title>
            <h3 class="h5 font-weight-bold">
              <v-icon color="black">mdi-medical-bag</v-icon>
              Available Centres
            </h3>
            <v-spacer></v-spacer>
            <v-btn
              color="warning darken-1"
              href="https://selfregistration.cowin.gov.in/"
              small
              elevation="0"
              target="_blank"
            >
              <v-icon small>mdi-account</v-icon>
              Login to CoWIN Portal</v-btn
            >
          </v-card-title>

          <v-divider></v-divider>
          <v-card-text>
            <v-data-iterator
              :items="filteredSlots"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
              :search="search"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                  dark
                  elevation="0"
                  rounded
                  color="primary"
                  class="mb-1"
                >
                  <v-text-field
                    rounded
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    dense
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                  ></v-text-field>
                  <template v-if="$vuetify.breakpoint.mdAndUp">
                    <v-spacer></v-spacer>
                    <v-select
                      rounded
                      v-model="sortBy"
                      flat
                      solo-inverted
                      hide-details
                      dense
                      :items="keys"
                      prepend-inner-icon="mdi-sort"
                      label="Sort by"
                    ></v-select>
                    <v-spacer></v-spacer>
                    <v-btn-toggle rounded small v-model="sortDesc" mandatory>
                      <v-btn small depressed color="primary" :value="false">
                        <v-icon>mdi-arrow-up</v-icon>
                      </v-btn>
                      <v-btn small depressed color="primary" :value="true">
                        <v-icon>mdi-arrow-down</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </template>
                </v-toolbar>

                <div class="mx-auto">
                  <v-chip-group
                    center-active
                    @change="filterResult()"
                    v-model="ageGroups"
                    active-class="deep-orange lighten-2 "
                    class="d-inline-block"
                    multiple
                    column
                  >
                    <v-chip filter :value="18">18+</v-chip>
                    <v-chip filter :value="40">40+</v-chip>
                    <v-chip filter :value="45">45+</v-chip>
                  </v-chip-group>

                  <v-chip-group
                    center-active
                    @change="filterResult()"
                    active-class="blue-grey darken-1 white--text"
                    class="d-inline-block"
                    multiple
                    v-model="vaccineTypes"
                    column
                  >
                    <v-chip filter value="COVAXIN">COVAXIN</v-chip>
                    <v-chip filter value="COVISHIELD">COVISHIELD</v-chip>
                    <v-chip filter value="SPUTNIK V">SPUTNIK V</v-chip>
                  </v-chip-group>

                  <v-chip-group
                    center-active
                    v-model="vaccineFee"
                    @change="filterResult()"
                    active-class="teal lighten-3 white--text"
                    class="d-inline-block"
                    multiple
                    column
                  >
                    <v-chip filter value="Free">Free</v-chip>
                    <v-chip filter value="Paid">Paid</v-chip>
                  </v-chip-group>
                  <v-chip-group
                    center-active
                    @change="
                      ageGroups = [];
                      vaccineFee = [];
                      vaccineTypes = [];
                      filterResult();
                    "
                    v-if="
                      ageGroups.length ||
                      vaccineFee.length ||
                      vaccineTypes.length
                    "
                    class="d-inline-block"
                  >
                    <v-chip value="Free" outlined>
                      <v-icon small>mdi-close</v-icon> clear all</v-chip
                    >
                  </v-chip-group>
                </div>
              </template>

              <template v-slot:default="props">
                <v-row class="mt-3">
                  <v-col
                    v-for="item in props.items"
                    :key="item.name"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                  >
                    <v-expand-transition>
                      <v-card class="rounded-lg" elevation="1">
                        <v-card-title
                          class="
                            body-1
                            font-weight-bold
                            grey--text
                            text--darken-3
                          "
                        >
                          {{ item.name }}
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-list dense>
                          <customItem
                            label="Name"
                            :value="item.name"
                            :sortBy="sortBy"
                            sort="name"
                            size="large"
                          ></customItem>

                          <v-list-item>
                            <v-list-item-content
                              :class="{
                                'warning--text': sortBy === 'block_name',
                              }"
                            >
                              <v-list-item-subtitle>
                                Block Name
                              </v-list-item-subtitle>
                              <v-list-item-title class="subtitle-2">
                                {{ item.block_name }}</v-list-item-title
                              >
                            </v-list-item-content>
                            <v-list-item-content
                              :class="{
                                'warning--text': sortBy === 'fee_type',
                              }"
                            >
                              <v-list-item-subtitle> Fee </v-list-item-subtitle>
                              <v-list-item-title class="subtitle-2">
                                {{ item.fee_type }}</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content
                              :class="{ 'warning--text': sortBy === 'pincode' }"
                            >
                              <v-list-item-subtitle>
                                Pincode
                              </v-list-item-subtitle>
                              <v-list-item-title class="subtitle-2">
                                {{ item.pincode }}</v-list-item-title
                              >
                            </v-list-item-content>
                            <v-list-item-content
                              :class="{ 'warning--text': sortBy === 'address' }"
                            >
                              <v-list-item-subtitle>
                                Address
                              </v-list-item-subtitle>
                              <v-list-item-title class="subtitle-2">
                                {{ item.address }}</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content
                              :class="{
                                'warning--text': sortBy === 'Availability',
                              }"
                            >
                              <v-list-item-subtitle>
                                Availability
                                <!-- </v-list-item-subtitle>
                            <v-list-item-title class="subtitle-1"> -->
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-content
                              :class="{
                                'warning--text': sortBy === 'Availability',
                              }"
                            >
                              <v-list-item-subtitle>
                                <div v-if="item.avail">
                                  <v-chip
                                    :color="
                                      (item.available_capacity_dose1 > 0
                                        ? 'green'
                                        : 'grey') + ' lighten-1'
                                    "
                                    class="mr-2 mb-1"
                                    small
                                    ><v-icon small>mdi-needle</v-icon> D1 :
                                    {{ item.available_capacity_dose1 }}
                                  </v-chip>
                                  <br />
                                  <v-chip
                                    :color="
                                      item.available_capacity_dose2 > 0
                                        ? ' warning '
                                        : ' grey '
                                    "
                                    class="text--red"
                                    small
                                    ><v-icon small>mdi-needle</v-icon> D2 :
                                    {{ item.available_capacity_dose2 }}
                                  </v-chip>
                                </div>
                                <v-chip
                                  v-else
                                  class="text-center"
                                  color="red lighten-2"
                                  small
                                >
                                  <v-icon small>mdi-needle</v-icon> Not
                                  Available
                                </v-chip>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <div v-if="item.avail">
                            <v-divider></v-divider>
                            <v-list-item>
                              <v-list-item-content class="py-1">
                                <v-list-item-subtitle class="text-center">
                                  <v-btn
                                    color="primary"
                                    outlined
                                    text
                                    ripple
                                    @click="showSlots(item)"
                                  >
                                    <v-icon>mdi-eye-outline</v-icon>
                                    View Sessions
                                  </v-btn>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </v-list>
                      </v-card>
                    </v-expand-transition>
                  </v-col>
                </v-row>
              </template>

              <template v-slot:footer>
                <v-row class="mt-2" align="center" justify="center">
                  <span class="grey--text">Items per page</span>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        dark
                        text
                        color="primary"
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ itemsPerPage }}
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(number, index) in itemsPerPageArray"
                        :key="index"
                        @click="updateItemsPerPage(number)"
                      >
                        <v-list-item-title>{{ number }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-spacer></v-spacer>

                  <span class="mr-4 grey--text">
                    Page {{ page }} of {{ numberOfPages }}
                  </span>
                  <v-btn
                    fab
                    dark
                    color="primary darken-3"
                    class="mr-1"
                    elevation="0"
                    small
                    @click="formerPage"
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    dark
                    color="primary darken-3"
                    class="ml-1"
                    elevation="0"
                    small
                    @click="nextPage"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-row>
              </template>
            </v-data-iterator>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-bottom-sheet inset v-model="bottomSheet" persistent class="pb-5 mb-5">
      <v-sheet class="text-center" min-height="350px" rounded>
        <v-btn
          class="mt-6 text-right"
          text
          color="error"
          @click="bottomSheet = !bottomSheet"
        >
          <v-icon>mdi-close</v-icon>
          close
        </v-btn>
        <div class="mb-5">
          <h1 class="h2 mb-2">
            {{ selectedItem.name }}
          </h1>
          <v-btn
            color="green"
            class="mb-2"
            elevation="0"
            dark
            :href="'https://wa.me/?text=' + textMessage()"
            target="_blank"
          >
            <v-icon>mdi-whatsapp</v-icon> Notify a friend
          </v-btn>
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle> Block Name </v-list-item-subtitle>
                <v-list-item-title class="subtitle-2">
                  {{ selectedItem.block_name }}</v-list-item-title
                >
              </v-list-item-content>
              <v-divider vertical></v-divider>

              <v-list-item-content>
                <v-list-item-subtitle> Address </v-list-item-subtitle>
                <v-list-item-title class="subtitle-2">
                  {{ selectedItem.address }}</v-list-item-title
                >
              </v-list-item-content>
              <v-divider vertical></v-divider>

              <v-list-item-content>
                <v-list-item-subtitle> Fee </v-list-item-subtitle>
                <v-list-item-title class="subtitle-2">
                  {{ selectedItem.fee_type }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>

          <v-simple-table class="pb-5">
            <thead>
              <tr>
                <th class="text-center">Date</th>
                <th class="text-center">Vaccine</th>
                <th class="text-center">Min. Age Limit</th>
                <th class="text-center">1st Dose</th>
                <th class="text-center">2nd Dose</th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="grey lighten-3 text-body-2"
                v-for="(session, i) in selectedItem.sessions"
                :key="i"
              >
                <td class="pa-1 text-sm-caption text-md-caption">
                  {{ session.date }}
                </td>
                <td class="pa-1">{{ session.vaccine }}</td>
                <td class="pa-1">{{ session.min_age_limit }}+</td>
                <td class="pa-1">
                  <v-chip
                    small
                    color="success"
                    v-if="session.available_capacity_dose1 > 0"
                    >{{ session.available_capacity_dose1 }} Nos</v-chip
                  >
                  <v-chip small color="red" v-else
                    >{{ session.available_capacity_dose1 }} Nos</v-chip
                  >
                </td>
                <td class="pa-1">
                  <v-chip
                    small
                    color="success"
                    v-if="session.available_capacity_dose2 > 0"
                    >{{ session.available_capacity_dose2 }} Nos</v-chip
                  >
                  <v-chip small color="red" v-else
                    >{{ session.available_capacity_dose2 }} Nos</v-chip
                  >
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-dialog v-model="dialog" width="700">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Notification Subscription
        </v-card-title>

        <v-card-text v-if="!isSubscribed">
          <v-row class="mt-5" no-gutters>
            <v-col cols="6">
              <v-autocomplete
                rounded
                :items="states"
                v-model="selectedState"
                label="State"
                item-text="state_name"
                item-value="state_id"
                outlined
                dense
                @change="getAllDistricts()"
                placeholder="State"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                rounded
                :items="districts"
                v-model="selectedDistrict"
                item-text="district_name"
                item-value="district_id"
                label="District"
                outlined
                dense
                @change="getSloteByDistrict()"
                placeholder="District"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-radio-group row dense v-model="ageGroup">
                <v-radio label="Age 18+" value="18"></v-radio>
                <v-radio label="Age 45+" value="45"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="6">
              <v-radio-group row dense v-model="dose">
                <v-radio label="Dose 1" value="1"></v-radio>
                <v-radio label="Dose 2" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                block
                x-large
                :disabled="
                  selectedDistrict == '' || dose == '' || ageGroup == ''
                "
                elevation="0"
                @click="
                  subscribe();
                  dialog = false;
                "
              >
                <v-icon>mdi-bell</v-icon>
                Turn On Notification</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-else class="text-center">
          <h1 class="mt-4 green--text">
            You Already Subscribed to Notification
          </h1>
          <v-btn color="red" class="mt-3" elevation="0" @click="unsubscribe()"
            >Reset Notification</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-btn
      elevation="2"
      color="indigo darken-4"
      dark
      fixed
      :left="10"
      :bottom="10"
      href="https://selfregistration.cowin.gov.in/ "
      target="_blank"
      >Go to CoWIN</v-btn
    >
  </v-container>
</template>

<script>
import axios from "axios";
import customItem from "../components/customItems";
import { messaging } from "../firebase/firebase";
export default {
  name: "Home",
  data: () => ({
    isSubscribed: false,
    bottomSheet: false,
    dialog: false,
    ageGroup: 18,
    dose: 1,
    itemsPerPageArray: [20, 40, 60, 80],
    selectedItem: { sessions: [] },
    filter: {},
    sortDesc: true,
    page: 1,
    itemsPerPage: 20,
    sortBy: "avail",
    keys: [
      { text: "All Dose Avail", value: "avail" },
      { text: "Dose 1", value: "available_capacity_dose1" },
      { text: "Dose 2", value: "available_capacity_dose2" },
      { text: "Fee", value: "fee_type" },
      { text: "Name", value: "name" },
      { text: "Block Name", value: "block_name" },
    ],
    selectedState: "",
    selectedDistrict: "",
    search: "",
    selectedInterval: 300000,
    isAutoRefresh: false,
    vaccineFee: [],
    ageGroups: [],
    vaccineTypes: [],
    slots: [],
    filteredSlots: [],
    expanded: false,
    timeInternvals: [
      {
        text: "1 Min",
        value: 60000,
      },
      {
        text: "2 Min",
        value: 120000,
      },
      {
        text: "3 Min",
        value: 180000,
      },
      {
        text: "5 Min",
        value: 300000,
      },
      {
        text: "15 Min",
        value: 900000,
      },
      {
        text: "30 Min",
        value: 1800000,
      },
      {
        text: "1 Hr",
        value: 3600000,
      },
    ],
    notificationCount: 0,
  }),
  components: {
    customItem,
  },
  methods: {
    getAllStates() {
      let states = "";
      this.states = states;
    },
    getAllDistricts() {
      let allDistricts = "";
      let selectedState = this.selectedState;

      let districtData = allDistricts.find((el) => {
        return el.state_id == selectedState;
      });
      this.districts = districtData.districts;
    },
    getSloteByDistrict() {
      // let today = new Date().toLocaleDateString();
      var config = {
        crossDomain: true,
        headers: {},
      };
      return axios
        .get(
          "https://kanak.digital/api/get-calendar/" + this.selectedDistrict,
          config
        )
        .then((res) => {
          this.slots = res.data.centers.map((center) => {
            return {
              ...center,
              ...this.checkSlotsAvailForParent(center),
            };
          });
          this.filterResult();
        });
    },
    checkSlotsAvail(item) {
      var avail = "red lighten-4";
      item.sessions.forEach((session) => {
        if (session.available_capacity > 0) {
          avail = "green lighten-4";
        }
      });
      return avail;
    },
    checkSlotsAvailForParent(item) {
      var avail = false;
      var totalDose1 = 0;
      var totalDose2 = 0;
      item.sessions.forEach((session) => {
        if (session.available_capacity > 0) {
          avail = true;
          totalDose1 += session.available_capacity_dose1;
          totalDose2 += session.available_capacity_dose2;
        }
      });
      return {
        avail: avail,
        available_capacity_dose1: totalDose1,
        available_capacity_dose2: totalDose2,
      };
    },
    saveTemp() {
      localStorage.setItem(
        "temp",
        JSON.stringify({
          state: this.selectedState,
          district: this.selectedDistrict,
        })
      );
    },

    startChecking() {
      if (this.isAutoRefresh) {
        setInterval(() => {
          this.getSloteByDistrict().then(() => {
            this.slots.map((slot) => {
              if (slot.avail) {
                new Notification(slot.block_name + " Available", {
                  body: "Please check ",
                  vibrate: true,
                });
              }
            });
          });
        }, this.selectedInterval);
      }
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    showSlots(item) {
      this.bottomSheet = true;
      this.selectedItem = item;
    },
    textMessage() {
      let slots = "\n";
      this.selectedItem.sessions.forEach((session) => {
        if (
          session.available_capacity_dose1 > 0 ||
          session.available_capacity_dose2 > 0
        ) {
          slots +=
            "*Date " +
            session.date +
            "* Dose 1 : _" +
            session.available_capacity_dose1 +
            "_  Dose 2 : _" +
            session.available_capacity_dose2 +
            "_ \n";
        }
      });

      return encodeURI(
        `I found below vaaccine Slots by using  https://vaccine-notify.web.app available at ${this.selectedItem.name}. You can book appointment at Vaccine portal : https://selfregistration.cowin.gov.in/  \n\n Details: \n ${slots}`
      );
    },
    subscribe() {
      Notification.requestPermission().then((res) => {
        if (res == "granted") {
          messaging
            .getToken({
              vapidKey:
                "BBdKP0lNlxJ6tAieALertQc2KIV_p-U1euF7fK9bycOQRfUiFB-SspSQ9vt5_5s9dQXYN1B1ecH8dnCnGl-2wz4",
            })
            .then((currentToken) => {
              axios
                .post("https://kanak.digital/api/subscribe", {
                  token: currentToken,
                  district: this.selectedDistrict,
                  age: this.ageGroup,
                  dose: this.dose,
                  status: 1,
                })
                .then(() => {
                  localStorage.setItem("isSubscribed", true);
                  this.isSubscribed = true;
                  this.saveTemp();
                });
            });
        } else {
          this.isSubscribed = false;
          alert(
            "Notification Denied ! \nPlease enable notification for this site and try again."
          );
          window.open(
            "https://support.google.com/chrome/answer/3220216?co=GENIE.Platform%3DDesktop&hl=en",
            "_blank"
          );
          // this.subscribe();
        }
      });
    },
    unsubscribe() {
      this.isSubscribed = false;
      localStorage.setItem("isSubscribed", false);
    },
    filterResult() {
      this.filteredSlots = this.slots.filter((center) => {
        var gate = true;
        if (this.vaccineFee.length > 0) {
          gate = this.vaccineFee.includes(center.fee_type);
        }
        if (this.ageGroups.length > 0) {
          gate = gate && this.checkAgeGroup(center);
        }
        if (this.vaccineTypes.length > 0) {
          gate = gate && this.checkVaccineType(center);
        }
        return gate;
      });
    },
    checkVaccineType(center) {
      var include = false;
      center.sessions.forEach((session) => {
        if (
          this.vaccineTypes.includes(session.vaccine) &&
          session.available_capacity > 0
        ) {
          include = true;
        }
      });
      return include;
    },
    checkAgeGroup(center) {
      var include = false;
      center.sessions.forEach((session) => {
        if (
          this.ageGroups.includes(session.min_age_limit) &&
          session.available_capacity > 0
        ) {
          include = true;
        }
      });
      return include;
    },
    checkNotificationSubscribed() {},
    getNotificationCount() {
      messaging
        .getToken({
          vapidKey:
            "BBdKP0lNlxJ6tAieALertQc2KIV_p-U1euF7fK9bycOQRfUiFB-SspSQ9vt5_5s9dQXYN1B1ecH8dnCnGl-2wz4",
        })
        .then((currentToken) => {
          axios
            .get(
              "https://kanak.digital/api/get_notification_count/" + currentToken
            )
            .then((res) => {
              this.notificationCount = res.data;
            });
        });
    },
  },
  created() {
    let temp = JSON.parse(localStorage.getItem("temp"));
    if (temp != null) {
      this.selectedState = temp.state;
      this.selectedDistrict = temp.district;
      this.getSloteByDistrict();
    }
    this.isSubscribed = JSON.parse(localStorage.getItem("isSubscribed"));
    this.getNotificationCount();
  },
  computed: {
    tableHeader() {
      return [
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Block Name",
          value: "block_name",
        },
        {
          text: "Pincode",
          value: "pincode",
        },
        {
          text: "Address",
          value: "address",
        },
        {
          text: "Fee",
          value: "fee_type",
        },

        {
          text: "Availability",
          value: "avail",
        },
        {
          text: "",
          value: "data-table-expand",
        },
      ];
    },
    numberOfPages() {
      return Math.ceil(this.filteredSlots.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key.value !== "name");
    },
    states() {
      return this.$store.getters.getAllStates;
    },
    districts() {
      return this.$store.getters.getDistrictByState(this.selectedState);
    },
  },
};
</script>
